// extracted by mini-css-extract-plugin
export default {"body_styleDefault":"c-a_fF","body_styleRed":"c-a_fG"};